import { COMPONENT_MAP } from '@/react/consts';

/**
 * Renders component strings by mapping component types to display names
 * @param {string[]} components - Array of component types
 * @returns {string} - Formatted component string joined with ' & '
 */
export const renderComponentString = (components) => {
  if (!Array.isArray(components)) {
    return '';
  }

  const mappedComponents = components
    .map((component) => COMPONENT_MAP[component])
    .filter(Boolean);

  // Remove duplicates to avoid showing "Embedded & Embedded"
  const uniqueComponents = [...new Set(mappedComponents)];

  return uniqueComponents.join(' & ');
};
